<!-- <div class="container">
  <div class="tabs">
    <button class="tab" [ngClass]="{'active': isTabActive}" (click)="alterTab(true)">ATIVOS</button>
    <button class="tab" [ngClass]="{'active': !isTabActive}" (click)="alterTab(false)">INATIVOS</button>
  </div>

  <div class="actions">
    <button class="new-client-btn" (click)="openModalRegistro()">NOVO CLIENTE</button>
    <div class="filters">
      <select class="filter-dropdown" (change)="alterRevendedor($event)">
        <option selected value="default">SELECIONE UM REVENDEDOR</option>
        <option *ngFor="let revendedor of revendedorList">{{revendedor}}</option>
      </select>
      <input type="text" class="filter-input" placeholder="Filtro" [(ngModel)]="filterName" />
      <button class="search-btn">
        <i class="material-icons">search</i>
      </button>
    </div>
  </div>
  <div class="div-clients-table">
  <table class="clients-table">
    <ng-container *ngIf="isTabActive">
      <thead>
        <tr>
          <th>ID</th>
          <th>Nome</th>
          <th>CPF/CNPJ</th>
          <th>Canais</th>
          <th>Nutrições</th>
          <th>Mensagens</th>
          <th>Host</th>
          <th>Opções</th>
        </tr>
      </thead>
    </ng-container>
    <ng-container *ngIf="!isTabActive">
      <thead>
        <tr>
          <th>ID</th>
          <th>NOME</th>
          <th>CPF/CNPJ</th>
          <th>EMAIL</th>
          <th>REVENDEDOR</th>
          <th>Opções</th>
        </tr>
      </thead>
    </ng-container>
    <tbody>
      <ng-container *ngIf="isTabActive">
        <tr *ngFor="let client of clients | clientFilterName : filterName | paginate: { itemsPerPage: objectPage.itemsPerPage, currentPage: objectPage.currentPage}">
          <td>{{ client.idcliente }}</td>
          <td>{{ client.nome }}</td>
          <td>{{ client.cpfcnpj }}</td>
          <td>{{ client.canais }}</td>
          <td>{{ client.nutricoes }}</td>
          <td>{{ client.mensagens }}</td>
          <td>{{ client.host }}</td>
          <td class="options">
            <button class="edit-btn" (click)="openModalEditClient(client)" title="Alterar dados de cadastro do cliente">
              <mat-icon>edit</mat-icon>
            </button>
            <button class="settings-btn" title="Alterar configurações do cliente"
              (click)="openModalEditConfigClient(client)">
              <mat-icon>settings</mat-icon>
            </button>
            <button class="link-btn" title="Alterar o host do cliente" (click)="openModalEditHostClient(client)">
              <mat-icon>link</mat-icon>
            </button>
            <button class="key-btn" title="Alterar a senha do cliente" (click)="openModalEditPasswordClient(client)">
              <mat-icon>key</mat-icon>
            </button>
            <button *ngIf="returnLevel() === 3" class="inactivate-btn" title="Inativar cliente"
              (click)="openModalDeleteClient(client)">
              <mat-icon>close</mat-icon>
            </button>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!isTabActive">
        <tr *ngFor="let client of clientsInactive | clientFilterName : filterName | paginate: { itemsPerPage: objectPage.itemsPerPage, currentPage: objectPage.currentPage}">
          <td>{{ client.idcliente }}</td>
          <td>{{ client.nome }}</td>
          <td>{{ client.cpfcnpj }}</td>
          <td>{{ client.email }}</td>
          <td>{{ client.revendedor }}</td>
          <td class="options">
            <button class="renew-btn" (click)="openModalRenewClient(client)" title="Reativar Cliente">
              <mat-icon>replay</mat-icon>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  </div>
  <div class="pagination">
    <span>Registros por página:</span>
    <select (change)="alterItemPerPage($event)">
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="20">20</option>
    </select>
    <span>
      <button (click)="previousPage()" [disabled]="isFirstPage()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      {{ objectPage.currentPage }} de {{ objectPage.totalPages }}
      <button (click)="nextPage()" [disabled]="isLastPage()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </span>
  </div>
</div> -->

<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Clientes</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie clientes ativos e inativos</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Acompanhe cadastros, acesse configuracoes e filtre rapidamente por revendedor ou nome.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Ativos</p>
        <strong class="text-lg">{{ clients.length }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Inativos</p>
        <strong class="text-lg">{{ clientsInactive.length }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div class="flex flex-wrap items-center gap-3">
        <div class="inline-flex items-center rounded-full border border-border-color bg-light-color/70 p-1 text-sm">
          <button
            type="button"
            class="rounded-full px-4 py-2 text-sm font-semibold transition"
            [ngClass]="isTabActive ? 'bg-white text-primary-color shadow-sm' : 'text-dark-color/70'"
            (click)="alterTab(true)">
            Ativos
          </button>
          <button
            type="button"
            class="rounded-full px-4 py-2 text-sm font-semibold transition"
            [ngClass]="!isTabActive ? 'bg-white text-primary-color shadow-sm' : 'text-dark-color/70'"
            (click)="alterTab(false)">
            Inativos
          </button>
        </div>
        <span class="text-sm text-dark-color/70">Clique para alternar entre clientes ativos e inativos.</span>
      </div>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
        (click)="openModalRegistro()">
        <mat-icon>add</mat-icon>
        Novo cliente
      </button>
    </div>

    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex flex-1 flex-wrap items-center gap-2">
        <label class="flex min-w-[220px] flex-1 items-center gap-2 rounded-base border border-border-color bg-light-color px-3 py-2 text-sm text-dark-color">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            class="w-full bg-transparent outline-none"
            placeholder="Buscar cliente"
            [(ngModel)]="filterName" />
        </label>
        <select
          class="min-w-[220px] flex-1 rounded-base border border-border-color bg-white px-3 py-2 text-sm text-dark-color"
          (change)="alterRevendedor($event)">
          <option selected value="default">Selecione um revendedor</option>
          <option *ngFor="let revendedor of revendedorList">{{ revendedor }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr *ngIf="isTabActive">
            <th class="px-4 py-3 text-left font-semibold text-dark-color">ID</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">CPF/CNPJ</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Canais</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nutricoes</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Mensagens</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Host</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Acoes</th>
          </tr>
          <tr *ngIf="!isTabActive">
            <th class="px-4 py-3 text-left font-semibold text-dark-color">ID</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">CPF/CNPJ</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Email</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Revendedor</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Acoes</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <ng-container *ngIf="isTabActive">
            <tr
              *ngFor="let client of clients | clientFilterName : filterName | paginate: { itemsPerPage: objectPage.itemsPerPage, currentPage: objectPage.currentPage }"
              class="transition hover:bg-light-color/60">
              <td class="px-4 py-3 text-dark-color">{{ client.idcliente }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.nome }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.cpfcnpj }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.canais }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.nutricoes }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.mensagens }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.host }}</td>
              <td class="px-4 py-3 text-right">
                <div class="flex justify-end gap-2">
                  <button
                    type="button"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                    (click)="openModalEditClient(client)"
                    title="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                    (click)="openModalEditConfigClient(client)"
                    title="Configurar">
                    <mat-icon>settings</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                    (click)="openModalEditHostClient(client)"
                    title="Host">
                    <mat-icon>link</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                    (click)="openModalEditPasswordClient(client)"
                    title="Senha">
                    <mat-icon>key</mat-icon>
                  </button>
                  <button
                    *ngIf="returnLevel() === 3"
                    type="button"
                    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                    (click)="openModalDeleteClient(client)"
                    title="Inativar">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!isTabActive">
            <tr
              *ngFor="let client of clientsInactive | clientFilterName : filterName | paginate: { itemsPerPage: objectPage.itemsPerPage, currentPage: objectPage.currentPage }"
              class="transition hover:bg-light-color/60">
              <td class="px-4 py-3 text-dark-color">{{ client.idcliente }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.nome }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.cpfcnpj }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.email }}</td>
              <td class="px-4 py-3 text-dark-color">{{ client.revendedor }}</td>
              <td class="px-4 py-3 text-right">
                <button
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  (click)="openModalRenewClient(client)"
                  title="Reativar">
                  <mat-icon>replay</mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="flex flex-col items-center justify-between gap-3 text-sm md:flex-row">
      <div class="flex items-center gap-2">
        <span>Registros por pagina:</span>
        <select
          class="rounded-base border border-border-color px-3 py-2 text-dark-color"
          (change)="alterItemPerPage($event)">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
        <span>Pagina {{ objectPage.currentPage }} de {{ objectPage.totalPages || 1 }}</span>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="isFirstPage()"
          (click)="previousPage()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>
        <span class="font-semibold">{{ objectPage.currentPage }}</span>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="isLastPage()"
          (click)="nextPage()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>


<ng-container *ngIf="openRegistro">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-6xl max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro</p>
          <h3 class="text-lg font-semibold text-dark-color">Novo cliente</h3>
          <p class="mt-1 text-sm text-dark-color/70">Preencha os dados principais para criar o cliente.</p>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalRegistro()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form
        class="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3"
        [formGroup]="formRegistro"
        (ngSubmit)="onSubmitRegistro()">
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-nome">
          <span class="font-semibold">Nome</span>
          <input
            type="text"
            id="cliente-nome"
            placeholder="Nome"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="nome">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('nome')?.invalid && formRegistro.get('nome')?.touched">
            O nome é obrigatório.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" *ngIf="returnLevel() === 3" for="cliente-revendedor">
          <span class="font-semibold">Revendedor</span>
          <select
            id="cliente-revendedor"
            class="rounded-base border border-border-color bg-white px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="revendedor">
            <option>Selecione uma opção..</option>
            <option *ngFor="let revendedor of revendedorListRegister">{{ revendedor.revendedor }}</option>
          </select>
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('revendedor')?.invalid && formRegistro.get('revendedor')?.touched">
            O revendedor é obrigatório.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-email">
          <span class="font-semibold">Email</span>
          <input
            type="email"
            id="cliente-email"
            placeholder="Email"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="email">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('email')?.invalid && formRegistro.get('email')?.touched">
            <ng-container *ngIf="formRegistro.get('email')?.errors?.['required']">O email é obrigatório.</ng-container>
            <ng-container *ngIf="formRegistro.get('email')?.errors?.['email']">Insira um email válido.</ng-container>
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-telefone">
          <span class="font-semibold">Telefone</span>
          <input
            type="text"
            id="cliente-telefone"
            placeholder="(99) 99999-9999"
            mask="(99) 99999-9999"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="telefone">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('telefone')?.invalid && formRegistro.get('telefone')?.touched">
            <ng-container *ngIf="formRegistro.get('telefone')?.errors?.['required']">O telefone é obrigatório.</ng-container>
            <ng-container *ngIf="formRegistro.get('telefone')?.errors?.['minlength'] && formRegistro.get('telefone')?.errors?.['pattern']">
              Insira um número valido com DDD e Numero.
            </ng-container>
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" *ngIf="returnLevel() === 2" for="cliente-valor-canal">
          <span class="font-semibold">Valor por canal</span>
          <input
            type="text"
            id="cliente-valor-canal"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="Valor por canal"
            formControlName="valorCanal"
            [value]="formattedValue"
            (input)="onInputChange($event)">
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-documento-tipo">
          <span class="font-semibold">Tipo de documento</span>
          <select
            id="cliente-documento-tipo"
            class="rounded-base border border-border-color bg-white px-3 py-2 text-sm outline-none focus:border-primary-color"
            (change)="alterDocument($event)">
            <option>CPF</option>
            <option>CNPJ</option>
          </select>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-documento">
          <span class="font-semibold">CPF/CNPJ</span>
          <input
            type="text"
            id="cliente-documento"
            [mask]="maskValue"
            placeholder="Digite o CPF ou CNPJ"
            formControlName="cpfcnpj"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('cpfcnpj')?.errors?.['required'] && formRegistro.get('cpfcnpj')?.touched">
            O CPF/CNPJ é obrigatório.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-senha">
          <span class="font-semibold">Senha</span>
          <div class="relative">
            <input
              [type]="typeInputEditPassword"
              id="cliente-senha"
              formControlName="password"
              class="w-full rounded-base border border-border-color px-3 py-2 pr-10 text-sm outline-none focus:border-primary-color"
              placeholder="Insira a nova senha">
            <button
              type="button"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-dark-color/70 transition hover:text-dark-color"
              (click)="toggleVisibility()">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('password')?.errors?.['required'] && formRegistro.get('password')?.touched">
            Insira uma senha.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color md:col-span-2 xl:col-span-3" for="cliente-host">
          <span class="font-semibold">Host</span>
          <input
            type="text"
            id="cliente-host"
            placeholder="Ex: http://teste.atenderbem.com"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="host">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('host')?.errors?.['required'] && formRegistro.get('host')?.touched">
            É necessário informar o host.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-quantidade-canais">
          <span class="font-semibold">Quantidade de canais</span>
          <input
            type="number"
            id="cliente-quantidade-canais"
            placeholder="Quantidade de canais"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="quantidadecanais">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('quantidadecanais')?.errors?.['required'] && formRegistro.get('quantidadecanais')?.touched">
            Insira a quantidade de canais.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-quantidade-mensagens">
          <span class="font-semibold">Quantidade de mensagens</span>
          <input
            type="number"
            id="cliente-quantidade-mensagens"
            placeholder="Quantidade de mensagens"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="quantidadeMensagem">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('quantidadeMensagem')?.errors?.['required'] && formRegistro.get('quantidadeMensagem')?.touched">
            Insira a quantidade de mensagens pre definidas.
          </small>
        </label>

        <label class="flex flex-col gap-2 text-sm text-dark-color" for="cliente-quantidade-nutricao">
          <span class="font-semibold">Quantidade de nutricao</span>
          <input
            type="number"
            id="cliente-quantidade-nutricao"
            placeholder="Quantidade de nutricao"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="quantidadeNutricao">
          <small class="text-xs text-red-500" *ngIf="formRegistro.get('quantidadeNutricao')?.errors?.['required'] && formRegistro.get('quantidadeNutricao')?.touched">
            Insira a quantidade de nutricoes.
          </small>
        </label>

        <div class="flex justify-end md:col-span-2 xl:col-span-3">
          <button
            type="submit"
            class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Cadastrar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- MODAL DE EDICAO DE CADASTRO DO CLIENTE -->
<ng-container *ngIf="activeModalEdit">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-3xl max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Atualizacao</p>
          <h3 class="text-lg font-semibold text-dark-color">Atualizar cadastro do cliente</h3>
          <p class="mt-1 text-sm text-dark-color/70">Edite os dados principais do cliente selecionado.</p>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalEditClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 grid gap-4 md:grid-cols-2" [formGroup]="formEditClient" (ngSubmit)="sendUpdateClient()">
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="edit-nome">
          <span class="font-semibold">Nome</span>
          <input
            type="text"
            id="edit-nome"
            value="{{clientEditSelected.nome}}"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="Nome"
            formControlName="nome">
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="edit-cpfcnpj">
          <span class="font-semibold">CPF/CNPJ</span>
          <input
            type="text"
            id="edit-cpfcnpj"
            value="{{clientEditSelected.cpfcnpj}}"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="CPF/CNPJ"
            formControlName="cpfcnpj">
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="edit-email">
          <span class="font-semibold">Email</span>
          <input
            type="text"
            id="edit-email"
            value="{{clientEditSelected.email}}"
            class="rounded-base border border-border-color bg-light-color/60 px-3 py-2 text-sm text-dark-color/70 outline-none"
            placeholder="Email"
            disabled>
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="edit-host">
          <span class="font-semibold">Host</span>
          <input
            type="text"
            id="edit-host"
            value="{{clientEditSelected.host}}"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="Host"
            formControlName="host">
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="edit-telefone">
          <span class="font-semibold">Telefone</span>
          <input
            type="text"
            id="edit-telefone"
            mask="(99) 99999-9999"
            value="{{clientEditSelected.telefone}}"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            placeholder="Telefone"
            formControlName="telefone">
        </label>

        <div class="flex justify-end md:col-span-2">
          <button
            type="submit"
            class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Atualizar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- Modal de edicao de configuracoes do cliente -->
<ng-container *ngIf="activeModalEditConfig">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-4xl max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Configuracoes</p>
          <h3 class="text-lg font-semibold text-dark-color">Canais, nutricoes e mensagens</h3>
          <p class="mt-1 text-sm text-dark-color/70">Ajuste limites e modulos do cliente.</p>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalEditConfigClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="mt-6 grid gap-6 md:grid-cols-3">
        <div class="flex flex-col items-center gap-3 rounded-xl border border-border-color bg-light-color/40 px-4 py-5 text-center">
          <p class="text-sm font-semibold text-dark-color">Canais</p>
          <div class="flex h-24 w-24 items-center justify-center rounded-full border-4 border-primary-color bg-white">
            <span class="text-2xl font-semibold text-dark-color">{{ clientConfigEditSelected.canais }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:bg-gray-300"
              [disabled]="menuUser != '3'"
              (click)="removeChannelClient(clientConfigEditSelected)"
              title="Para reduzir canais, favor entrar em contato com o suporte">
              <mat-icon>remove</mat-icon>
            </button>
            <ng-container *ngIf="returnLevel() === 3">
              <button
                class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
                (click)="addChannelClient(clientConfigEditSelected)">
                <mat-icon>add</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="returnLevel() <= 2">
              <button
                class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
                (click)="openModalQntChannel()">
                <mat-icon>add</mat-icon>
              </button>
            </ng-container>
          </div>
        </div>

        <div class="flex flex-col items-center gap-3 rounded-xl border border-border-color bg-light-color/40 px-4 py-5 text-center">
          <p class="text-sm font-semibold text-dark-color">Nutricoes</p>
          <div class="flex h-24 w-24 items-center justify-center rounded-full border-4 border-primary-color bg-white">
            <span class="text-2xl font-semibold text-dark-color">{{ clientConfigEditSelected.nutricoes }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
              (click)="removeNutritionClient(clientConfigEditSelected)">
              <mat-icon>remove</mat-icon>
            </button>
            <button
              class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
              (click)="addNutritionClient(clientConfigEditSelected)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <div class="flex flex-col items-center gap-3 rounded-xl border border-border-color bg-light-color/40 px-4 py-5 text-center">
          <p class="text-sm font-semibold text-dark-color">Mensagens</p>
          <div class="flex h-24 w-24 items-center justify-center rounded-full border-4 border-primary-color bg-white">
            <span class="text-2xl font-semibold text-dark-color">{{ clientConfigEditSelected.mensagens }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
              (click)="removeMessagePredefined(clientConfigEditSelected)">
              <mat-icon>remove</mat-icon>
            </button>
            <button
              class="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-color text-white shadow transition hover:bg-primary-hover"
              (click)="addMessagePredefined(clientConfigEditSelected)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-3">
        <div class="flex items-center justify-between rounded-xl border border-border-color bg-white px-4 py-3">
          <div>
            <h4 class="text-sm font-semibold text-dark-color">Módulo de Agendas</h4>
            <p class="text-xs text-dark-color/70">Ative ou desative o módulo de agendamento</p>
          </div>
          <button
            type="button"
            (click)="handleToggleAgendaMenu(clientConfigEditSelected)"
            [attr.aria-pressed]="clientConfigEditSelected.agendaMenu"
            class="relative inline-flex h-7 w-14 items-center rounded-full transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            [ngClass]="clientConfigEditSelected.agendaMenu ? 'bg-green-500' : 'bg-gray-300'">
            <span class="sr-only">Ativar Agendas</span>
            <span
              class="inline-block h-6 w-6 transform rounded-full bg-white shadow transition"
              [ngClass]="clientConfigEditSelected.agendaMenu ? 'translate-x-7' : 'translate-x-1'"></span>
          </button>
        </div>

        <div class="flex items-center justify-between rounded-xl border border-border-color bg-white px-4 py-3">
          <div>
            <h4 class="text-sm font-semibold text-dark-color">Integração Clinicorp</h4>
            <p class="text-xs text-dark-color/70">Habilite o módulo Clinicorp para este cliente</p>
          </div>
          <button
            type="button"
            (click)="handleToggleClinicorpMenu(clientConfigEditSelected)"
            [attr.aria-pressed]="clientConfigEditSelected.clinicorpMenu"
            class="relative inline-flex h-7 w-14 items-center rounded-full transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            [ngClass]="clientConfigEditSelected.clinicorpMenu ? 'bg-green-500' : 'bg-gray-300'">
            <span class="sr-only">Ativar Clinicorp</span>
            <span
              class="inline-block h-6 w-6 transform rounded-full bg-white shadow transition"
              [ngClass]="clientConfigEditSelected.clinicorpMenu ? 'translate-x-7' : 'translate-x-1'"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>



<ng-container *ngIf="activeModalEditHost">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Host</p>
          <h3 class="text-lg font-semibold text-dark-color">Editar host do cliente</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalEditHostClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <form class="mt-4 flex flex-col gap-4" [formGroup]="formEditClientHost" (ngSubmit)="submitUpdateHostClient()">
        <label for="host-name" class="flex flex-col gap-2 text-sm text-dark-color">
          <span class="font-semibold">Host</span>
          <input
            type="text"
            id="host-name"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="host"
            placeholder="Digite o host">
        </label>
        <div class="flex justify-end">
          <button
            type="submit"
            class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="activeModalEditPassword">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Senha</p>
          <h3 class="text-lg font-semibold text-dark-color">Editar senha do cliente</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalEditPasswordClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <form class="mt-4 flex flex-col gap-4" [formGroup]="formEditClientPassword" (ngSubmit)="submitUpdatePasswordClient()">
        <label for="password" class="flex flex-col gap-2 text-sm text-dark-color">
          <span class="font-semibold">Nova senha</span>
          <div class="relative">
            <input
              [type]="typeInputEditPassword"
              id="password"
              formControlName="password"
              class="w-full rounded-base border border-border-color px-3 py-2 pr-10 text-sm outline-none focus:border-primary-color"
              placeholder="Insira a nova senha">
            <button
              type="button"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-dark-color/70 transition hover:text-dark-color"
              (click)="toggleVisibility()">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
        </label>
        <div class="flex justify-end">
          <button
            type="submit"
            class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="activeModalDeleteClient">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Inativar cliente</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalDeleteClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-4 text-sm text-dark-color">Deseja realmente inativar este cliente?</p>
      <div class="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm font-semibold text-white transition hover:border-primary-color"
          (click)="closeModalDeleteClient()">
          Cancelar
        </button>
        <button
          type="button"
          class="rounded-base bg-red-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-600"
          (click)="submitDeleteClient()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="activeModalRenewClient">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Reativar cliente</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalRenewClient()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-4 text-sm text-dark-color">
        Deseja realmente reativar este cliente: {{ clienteRenewSelected.nome }}
      </p>
      <div class="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover"
          (click)="submitRenewClient()">
          Reativar
        </button>
        <button
          type="button"
          class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm font-semibold text-white transition hover:border-primary-color"
          (click)="closeModalRenewClient()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="activeModalEditQuantidadeCanais">
  <div class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Canais</p>
          <h3 class="text-lg font-semibold text-dark-color">Adicionar canais</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalQntChannel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <form class="mt-4 flex flex-col gap-4" [formGroup]="formQuantidadeCanais" (ngSubmit)="submitAddQntCanais()">
        <label for="channel-number" class="flex flex-col gap-2 text-sm text-dark-color">
          <span class="font-semibold">Quantidade de canais</span>
          <input
            type="number"
            min="1"
            id="channel-number"
            name="channel-number"
            placeholder="Digite a quantidade de canais"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="quantidadecanais" />
        </label>
        <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="submit"
            class="inline-flex items-center gap-2 rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:bg-gray-400"
            [disabled]="isLoadingAdicionar || isLoadingAdicionarCredits">
            <span *ngIf="isLoadingAdicionar" class="spinner"></span>
            Adicionar - PIX
          </button>
          <button
            type="button"
            class="inline-flex items-center gap-2 rounded-base border border-border-color bg-gray-200 px-6 py-2 text-sm font-semibold text-gray-600 transition hover:border-primary-color hover:text-primary-color disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="isLoadingAdicionar || isLoadingAdicionarCredits"
            (click)="submitAddQntCanaisCredits()">
            <span *ngIf="isLoadingAdicionarCredits" class="spinner"></span>
            Adicionar - Créditos
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<app-loading-modal></app-loading-modal>

<app-alert></app-alert>

<app-pix-modal></app-pix-modal>
